// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1rrse","rightAdornment":"Header_rightAdornment__Iyb-a"};